import React, { lazy } from 'react';
import { AllowByFlag } from '../components/permission';
import KYCAdminReview from '../pages/admin/kyc/KYCAdminReview';
const Adjustments = lazy(() => import('../pages/tools/adjustments'));
const Reports = lazy(() => import('../pages/reports/reports'));
const MediaList = lazy(() => import('../pages/tools/mediaList'));
const Schedule = lazy(() => import('../pages/tools/schedule'));
const Training = lazy(() => import('../pages/tools/training'));
const EditCourse = lazy(() => import('../pages/tools/editCourse'));
const Subscription = lazy(() => import('../pages/customers/subscription'));
const Services = lazy(() => import('../pages/customers/services'));
const Glossary = lazy(() => import('../pages/inventory/glossary'));
const FAQ = lazy(() => import('../pages/tools/faq'));
const PageAlert = lazy(() => import('../pages/tools/alerts/PageAlert'));

const routes = [
  {
    path: 'tools/adjustments',
    element: <Adjustments />,
  },
  {
    path: 'tools/page-alerts',
    element: <PageAlert />,
  },
  {
    path: 'training',
    element: <Training />,
  },
  {
    path: 'training/:courseId',
    element: <EditCourse />,
  },
  {
    path: 'glossary',
    element: <Glossary />,
  },

  {
    path: 'faq',
    element: <FAQ />,
  },
  {
    path: 'media',
    element: <MediaList />,
  },
  {
    path: 'schedule',
    element: <Schedule />,
  },
  {
    path: 'subscription',
    element: <Subscription />,
  },
  {
    path: 'services',
    element: <Services />,
  },
  {
    path: 'tools/kyc',
    element: (
      <AllowByFlag flagKey='KYC_ADMIN' redirect='/'>
        <KYCAdminReview />
      </AllowByFlag>
    ),
  },
];

export default routes;
